import { render, staticRenderFns } from "./BAutocomplete.vue?vue&type=template&id=a0f59ba2"
import script from "./BAutocomplete.vue?vue&type=script&lang=js"
export * from "./BAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports